
// import "smooth-scroll";
import SmoothScroll from 'smooth-scroll';

//attached to window load, executed after all css and images are loaded. see https://stackoverflow.com/questions/807878/how-to-make-javascript-execute-after-page-load
(function($) { "use strict";
	
	var scroll = new SmoothScroll('a[href*="#"]');

})(jQuery);





